export enum enumUSSDPortalID {
  SureCardUSSD= 3,
  mediBucksUSSD= 7
}

export namespace enumUSSDPortalID {
  export function values() {
    return Object.keys(enumUSSDPortalID).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}

